import { ConsumablesMasterThemeSizeConfig } from './types';

const small: ConsumablesMasterThemeSizeConfig = {
  consumablesMaster: {},
};

export default small;
